import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { AppShell } from "./ui/AppShell/index";
import { startAnimatedDocumentTitle } from "./utils/titleAnimation";

const RuntimeBootstrap = () => {
  useEffect(() => {
    const stopTitleAnimation = startAnimatedDocumentTitle({
      originalTitle: "IKaniewski",
    });

    void import("./main");

    return () => {
      stopTitleAnimation();
    };
  }, []);

  return <AppShell />;
};

const rootElement = document.getElementById("app-root");

if (rootElement) {
  createRoot(rootElement).render(<RuntimeBootstrap />);
}
